export enum Role {
  ADMIN = "ADMIN",
  SUPPORT = "SUPPORT",
  PRODUCTION_MANAGER = "PRODUCTION_MANAGER",
  CONTACT_CENTER = "CONTACT_CENTER",
}